/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetAccountTransactions200,
  GetAccountTransactionsParams
} from './schema'



/**
 * Retrieve a collection of account transactions in reverse chronological order
 * @summary Get Account Transactions
 */
export const getAccountTransactions = (
    params?: GetAccountTransactionsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetAccountTransactions200>> => {
    return axios.get(
      `/accounts/transactions`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetAccountTransactionsQueryKey = (params?: GetAccountTransactionsParams,) => [`/accounts/transactions`, ...(params ? [params]: [])];

    
export type GetAccountTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountTransactions>>>
export type GetAccountTransactionsQueryError = AxiosError<unknown>

export const useGetAccountTransactions = <TData = Awaited<ReturnType<typeof getAccountTransactions>>, TError = AxiosError<unknown>>(
 params?: GetAccountTransactionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountTransactions>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountTransactionsQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountTransactions>>> = ({ signal }) => getAccountTransactions(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getAccountTransactions>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

